export const EVENTS = {
    MEMORY_APPROVED: 'memoryApproved',
    MEMORY_DISCARDED: 'memoryDiscarded'
};

export const eventBus = {
    emit: (eventName, data = null) => {
        const event = new CustomEvent(eventName, { detail: data });
        window.dispatchEvent(event);
    },

    on: (eventName, callback) => {
        window.addEventListener(eventName, callback);
    },

    off: (eventName, callback) => {
        window.removeEventListener(eventName, callback);
    }
};